/**
 * Archivo: UsuariosAdmin.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 2024-07-10
 * 
 * Descripción:
 * Este componente define la vista para la administración de usuarios dentro de la aplicación. Permite listar, añadir,
 * y eliminar usuarios, así como realizar búsquedas y filtrados.
 * 
 * Dependencias:
 * - react: ^18.2.0
 * - xlsx: ^0.17.0
 * - js-cookie: ^3.0.1
 * - Componentes/MetaTags: Componente para las etiquetas meta del documento.
 * - Componentes/Cabecera: Componente para la cabecera principal de la aplicación.
 * - Componentes/SegundaCabecera: Componente para la segunda cabecera.
 * - Servicios/ColegialesServicios: Funciones para interactuar con el servicio de colegiales.
 * 
 * Propósito:
 * Proveer una interfaz de usuario para la administración de usuarios, gestionando la creación, modificación y
 * eliminación de cuentas, así como la asignación de permisos.
 */

import { default as React, useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import Cookies from 'js-cookie';
import MetaTags from '../Componentes/MetaTags';
import Cabecera from '../Componentes/Cabecera';
import SegundaCabecera from '../Componentes/SegundaCabecera';
import '../Estilos/estilos.css';

import lupaNegra from '../Imagenes/Iconos/LupaNegra.png'
import cruzNegra from '../Imagenes/Iconos/CruzNegra.png'

function VentanaAñadirUsuarios ({ onClose, añadirUsuario, añadirUsuarios, mensajeError, mensajeExito }) {
    const [correo, setCorreo] = useState('');
    const [permiso, setPermiso] = useState('Colegial');
    const [archivo, setArchivo] = useState('');

    const manejarArchivo = (e) => {
        setArchivo(e.target.files[0]);
    };

    const manejarAñadirUsuario = () => {
        añadirUsuario(correo, permiso);
    };

    const manejarAñadirUsuarios = () => {
        añadirUsuarios(archivo);
    };

    return (
        <div className="container col-xl-6 col-lg-7 col-md-8 bdr-1 rounded p-xl-2 p-lg-1 p-md-0 position-fixed " style={{ fontWeight: '3rem', background: '#D9D9D9', top: '44%', left: '50%', transform: 'translate(-50%, -40%)', zIndex:'5' }}>
            <div className="row-fluid pb-0 d-flex">
                <div className="container col-12 pb-1 text-start" style={{ borderBottom: '2px solid white' }}>
                <span className="customFontSizeTitulos text-black"> Añadir usuarios </span>
                <img
                    src={cruzNegra}
                    alt="login-icon"
                    className="card-img-top"
                    style={{ position:'absolute', height: '3rem', width: '3rem',cursor:'pointer', top:0, right:0 }}
                    onClick={onClose}
                />
                </div>
            </div>
            <div className='container-fluid pb-1 pt-1'>             
                <form onSubmit={(e) => { e.preventDefault(); manejarAñadirUsuario(); }}>
                    <span className='text-black customFontSizeTextoPequeño pt-2' style={{ fontWeight: 'bold' }}>Introduzca el correo del usuario al que le quiere dar acceso a la aplicación. </span>
                    <div className="form-group">
                        <input
                            type="email"
                            className="form-control"
                            placeholder="correo@unizar.es"
                            value={correo}
                            onChange={(e) => setCorreo(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <span className='text-black customFontSizeTextoPequeño' style={{ fontWeight: 'bold' }}>Seleccione los permisos que le quieres otorgar. </span>
                        <select className="form-control" value={permiso} onChange={(e) => setPermiso(e.target.value)}>
                            <option value="Colegial">Colegial</option>
                            <option value="Administrador">Administrador</option>
                            <option value="Conserjería">Conserjería</option>
                        </select>
                    </div>
                    <button type="submit" className='text-white' style={{backgroundColor:'Black', borderRadius: '50px', cursor: 'pointer', padding:'5px 10px'}}>
                        Añadir usuario
                    </button>
                </form>
                <form onSubmit={(e) => { e.preventDefault(); manejarAñadirUsuarios(); }} className='mt-4'>
                    <div className="form-group">
                        <span className='text-black customFontSizeTextoPequeño' style={{ fontWeight: 'bold' }}>Añadir más de un usuario a la vez (csv o xlsx). </span>
                        <input
                            type="file"
                            className="form-control-file"
                            onChange={manejarArchivo}
                        />
                    </div>
                    <button type="submit" className='text-white' style={{backgroundColor:'Black', borderRadius: '50px', cursor: 'pointer', padding:'5px 10px'}}>
                        Añadir usuarios
                    </button>
                </form>
                {mensajeError && <div className="alert alert-danger mt-3" role="alert">{mensajeError}</div>}
                {mensajeExito && <div className="alert alert-success mt-3" role="alert">{mensajeExito}</div>}
            </div>
        </div>
    );
};

function UsuariosAdmin() {
    const API = process.env.REACT_APP_API_BASE_URL; 
    const urlUsuarios = `${API}/api/usuarios`;
    const urlUsuariosCSV = `${API}/api/usuarios/csv`;
    const urlDeleteColegiales = `${API}/api/usuarios/colegiales`;

    const [token, setToken] = useState('');
    const [permisos, setPermisos] = useState(null);
    const [usuarios, setUsuarios] = useState({
        Usuarios: [],
        Administradores: [],
        Conserjería: [],
        Colegial: [],
        Indefinido: []
    });

    const [mensajeError, setMensajeError] = useState('');
    const [mensajeExito, setMensajeExito] = useState('');

    // Estado para el término de búsqueda
    const [searchTerm, setSearchTerm] = useState('');
    // Estado para los usuarios filtrados
    const [filteredUsuarios, setFilteredUsuarios] = useState({
        Usuarios: [],
        Administradores: [],
        Conserjería: [],
        Colegial: [],
        Indefinido: []
    });
    
    const [hayVentanas, setHayVentanas] = useState(false);

    //Variable para gestionar el modal de cerrar sesión
    const [mostrarAñadirUsuario, setMostrarAñadirUsuario] = useState(false);
    const handleAñadirUsuario = () => {
        //console.log('Mostrar añadir Usuario');
        setHayVentanas(true)
        setMostrarAñadirUsuario(true);
    };
    const closeCerrarAñadirUsuario = () => {
        setMensajeError('')
        setMensajeExito('')
        setHayVentanas(false)
        setMostrarAñadirUsuario(false);
    };

    //Fech para listar todos los usuarios
    useEffect(() => {
        const tokenNuevo = Cookies.get('token');
        const permisosNuevos = Cookies.get('permisos');
        setToken(tokenNuevo)
        setPermisos(permisosNuevos)
        //console.log("Token:", tokenNuevo, " Permisos:", permisosNuevos);

        fetch(urlUsuarios, {
            method: 'GET', 
            headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${tokenNuevo}`,
            },
        })
        .then(response => {
            //console.log(response)
            return response.json();
        })
        .then(data => {
            //console.log('Respuesta de la API:', data);
            setUsuarios(data.body); // Actualiza el estado con los datos de la API
            })
            .catch(error => {
            console.error('Error al enviar la solicitud:', error);
            });
    }, []);

    // Efecto para filtrar usuarios cada vez que el término de búsqueda cambie
    useEffect(() => {
        const filterUsuarios = (usuarios, term) => {
            if (!term) return usuarios;
            const lowercasedTerm = term.toLowerCase();
            const filterByTerm = (list) => list.filter((user) => user.correo_usuario.toLowerCase().includes(lowercasedTerm));

            return {
                Administradores: filterByTerm(usuarios.Administradores),
                Conserjería: filterByTerm(usuarios.Conserjería),
                Colegial: filterByTerm(usuarios.Colegial),
                Indefinido: filterByTerm(usuarios.Indefinido),
            };
        };

        setFilteredUsuarios(filterUsuarios(usuarios, searchTerm));
    }, [searchTerm, usuarios]);

    //Función para añadir un usuario a la lista de usuarios permitidos
    const añadirUsuario = async (correo, permisos) => {
        //console.log("Añadiendo usuario con: ", correo, permisos)

        if (correo === '' || permisos === '') {
            setMensajeError('Alguno de los campos está vacío')
        } else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo)) {
            setMensajeError('El correo está mal escrito')
        } else if (permisos !== 'Administrador' && permisos !== 'Conserjería' && permisos !== 'Colegial') {
            setMensajeError('Permisos incorrectos');
        } else {
            fetch(urlUsuarios, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ 
                    correo: correo, 
                    permisos: permisos 
                }),
            })
            .then((response) => response.json())
            .then((data) => {
                //console.log("Respuesta de la API: ", data)
                if (data.errors) {
                    console.log('Error al insertar usuario: ' + data.errors.map(err => err.msg).join(', '));
                    setMensajeError('Error al insertar usuario: ' + data.errors.map(err => err.msg).join(', '));
                    setMensajeExito('');
                } else {
                    console.log('Usuario insertado con éxito');
                    setUsuarios(data.body);
                    setMensajeExito('Usuario insertado con éxito'); // Actualiza el mensaje de éxito
                    setMensajeError(''); // Limpia el mensaje de error
                }
            })
            .catch(error => {
                console.error('Error al enviar la solicitud:', error);
                setMensajeError('Error al enviar la solicitud'); // Actualiza el mensaje de error
                setMensajeExito(''); // Limpia el mensaje de éxito
            });
        }
    };

    //Función para añadir un usuario a la lista de usuarios permitidos
    const añadirUsuarios = async (archivo) => {
        if (archivo !== '' && archivo !== null) {
            const archivoNombre = archivo.name;
            const extension = archivoNombre.split('.').pop().toLowerCase();
            if (extension !== 'csv' && extension !== 'xlsx' && extension !== 'xls') {
                setMensajeError("Introduce un archivo csv, xls o xlsx")
            }
            else {
                //Formato correcto, voy a validar el contenido del archivo y si está bien lo envío al back
                const reader = new FileReader();

                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];
                    let jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 1 });
                    jsonData = jsonData.filter(fila => fila.some(elemento => typeof elemento === 'string' && elemento.trim() !== ''));
                    
                    //console.log("Contenido del archivo: ", jsonData)
                    
                    // Inicializamos una variable para guardar mensajes de error
                    let errores = [];
        
                    if (jsonData.length === 0 || jsonData === '') {
                        errores.push('El archivo está vacío');
                    } else if (Object.keys(jsonData[0]).length !== 2) {
                        errores.push('El archivo debe contener exactamente dos campos: correo y permisos');
                    } else {
                        jsonData.forEach((fila, index) => {
                            const correo = fila[0];
                            const permisos = fila[1];
                            //console.log("Correo:", correo, " Permisos:", permisos, "fila:", index)
                            if (correo === '' || permisos === '') {
                                errores.push('Alguno de los campos del usuario en la fila '+ (index+1) + ' esta vacío.')
                            } else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo)) {
                                errores.push('El correo del usuario de la fila ' + (index+1) + ' está mal escrito.')
                            } else if (permisos !== 'Administrador' && permisos !== 'Conserjería' && permisos !== 'Colegial') {
                                errores.push('El usuario de la fila ' + (index+1) + ' tiene permisos incorrectos');
                            }
                        });
                    }
                    if (errores.length > 0) {
                        setMensajeError(errores.join(' '));
                    } else {
                        //console.log('Usuarios a insertar: ', jsonData)
                        setMensajeError('');
                        fetch(urlUsuariosCSV, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            },
                            body: JSON.stringify({ 
                                usuarios: jsonData 
                            }),
                        })
                        .then((response) => response.json())
                        .then((data) => {
                            //console.log("Respuesta de la API: ", data)
                            if (data.errors) {
                                console.log('Error al insertar usuario: ' + data.errors.map(err => err.msg).join(', '));
                                setMensajeError('Error al insertar usuario: ' + data.errors.map(err => err.msg).join(', '));
                                setMensajeExito('');
                            } else {
                                console.log('Usuarios insertados con éxito');
                                setUsuarios(data.body);
                                setMensajeExito('Usuarios insertados con éxito');
                                setMensajeError('');
                            }
                        })
                        .catch(error => {
                            console.error('Error al enviar la solicitud:', error);
                            setMensajeError('Error al enviar la solicitud');
                            setMensajeExito('');
                        });
                    }
                };
                reader.readAsArrayBuffer(archivo);
            }
        }
        else{
            setMensajeError("Introduce un archivo válido")
        }
    };

    //Función para añadir un usuario a la lista de usuarios permitidos
    const eliminarUsuario = async (correo) => {
        fetch(urlUsuarios, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ 
            correo: correo
            }),
        })
        .then((response) => response.json())
        .then((data) => {
        //console.log("Respuesta de la API: ", data)
        if (data.errors) {
            console.log('Error al eliminar usuario: ' + data.errors.map(err => err.msg).join(', '));
        } else {
            console.log('Usuario eliminado con éxito');
            setUsuarios(data.body);
        }
        })
        .catch(error => {
            console.error('Error al enviar la solicitud:', error);
        });
    };

    //Función para eliminar los usaurios colegiales
    const eliminarColegiales = async () => {
        fetch(urlDeleteColegiales, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            //body: JSON.stringify({}),
        })
        .then((response) => response.json())
        .then((data) => {
        //console.log("Respuesta de la API: ", data)
        if (data.errors) {
            console.log('Error al eliminar usuario: ' + data.errors.map(err => err.msg).join(', '));
        } else {
            console.log('Usuario eliminado con éxito');
            setUsuarios(data.body);
        }
        })
        .catch(error => {
            console.error('Error al enviar la solicitud:', error);
        });
    };

    const renderUsuarios = (usuarios) => {
        return (
            <div className='container-fluid p-0'>
                <div className='container-fluid pb-2'>
                    <span className='text-black customFontSizeTextoMediano'style={{fontWeight:'bold'}} >Administradores: </span>
                    {usuarios.Administradores.map((usuario, index) => (
                        <div key={index} className='container-fluid p-1 pr-3 mb-2 d-flex justify-content-between' style={{border:'1px solid black'}}>
                            {usuario.correo_usuario} 
                            <span className='customFontSizeTextoPequeño' style={{color:'red', cursor:'pointer'}} onClick={() => eliminarUsuario(usuario.correo_usuario)}>Eliminar</span>
                        </div>
                    ))}
                </div>
                <div className='container-fluid pb-2'>
                    <span className='text-black customFontSizeTextoMediano' style={{fontWeight:'bold'}}>Conserjería: </span>
                    {usuarios.Conserjería.length > 0 ? (
                        usuarios.Conserjería.map((usuario, index) => (
                            <div key={index} className='container-fluid p-1 pr-3 mb-2 d-flex justify-content-between' style={{border:'1px solid black'}}>
                                {usuario.correo_usuario} 
                                <span className='customFontSizeTextoPequeño' style={{color:'red', cursor:'pointer'}} onClick={() => eliminarUsuario(usuario.correo_usuario)}>Eliminar</span>
                            </div>
                        ))
                    ) : (
                        <span className='text-secondary customFontSizeTextoMediano'> No hay ningún usuario con estos permisos </span>
                    )}
                </div>
                <div className='container-fluid pb-2'>
                    <div className='d-flex justify-content-between'>
                        <span className='text-black customFontSizeTextoMediano' style={{fontWeight:'bold'}}>Colegiales: [{usuarios.Colegial.length}]</span>
                        {usuarios.Colegial.length > 0 ? (<span className='text-black customFontSizeTextoMuyPequeño' style={{fontWeight:'bold', cursor:'pointer'}} onClick={() => eliminarColegiales()}>Borrar todos los usuarios colegiales </span> ) : (<></>)}
                    </div>
                    {usuarios.Colegial.length > 0 ? (
                        usuarios.Colegial.filter(usuario => usuario.correo_usuario.toLowerCase().includes(searchTerm.toLowerCase())).map((usuario, index) => (
                            <div key={index} className='container-fluid p-1 pr-3 mb-2 d-flex justify-content-between' style={{border:'1px solid black'}}>
                                {usuario.correo_usuario}
                                <span className='customFontSizeTextoPequeño' style={{color:'red', cursor:'pointer'}} onClick={() => eliminarUsuario(usuario.correo_usuario)}>Eliminar</span> 
                            </div>
                        ))
                    ) : (
                        <span className='text-secondary customFontSizeTextoMediano'>No hay ningún usuario con estos permisos</span>
                    )}
                </div>
            </div>
        )
    };

    return (
    <>
    <MetaTags /> 
    <div className="fondo">
        {/**CABECERA*/}
        <Cabecera permisos={permisos}/>
        {/** PANTALLA GRANDE */}
        <div className='d-none d-md-block '>
            {/**SEGUNDA CABECERA ADMIN*/}
            <SegundaCabecera hayVentanas={hayVentanas} permisos={permisos}  />
            {/* Renderizo la ventana de Añadir Usuarios */}
            {mostrarAñadirUsuario&& <VentanaAñadirUsuarios onClose={closeCerrarAñadirUsuario} añadirUsuario={añadirUsuario} añadirUsuarios={añadirUsuarios}
             mensajeError={mensajeError} mensajeExito={mensajeExito} />}
            {/**Usuarios*/}
            <div className='container-fluid d-flex pt-2 pr-2 pl-2 mt-2'style={{opacity: hayVentanas ? 0.4 : 1}} >
                <div className='container-fluid d-flex p-2'>
                    <div className='col-4'>
                        <span className='text-black customFontSizeTextoPequeño' > Estos son los usuarios que tienen acceso a la aplicación </span>
                    </div>
                    <div className='col-5'>
                        <form className="d-flex position-relative mt-1" role="search" >
                            <div className="input-group">
                            <input
                                aria-label="Search"
                                className="form-control me-2"
                                placeholder="Buscar"
                                style={{ borderRadius: '2rem', border: '1px solid black', height: '2rem' }}
                                type="search"
                                value={searchTerm} 
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                                <button className="btn btn-outline-success" style={{ backgroundColor: 'transparent', border: 'none', bottom: '0', marginTop: '-0.2rem',  position: 'absolute', right: '0', top: '0', zIndex: '3'}} 
                                onClick={(e) => e.preventDefault()} >
                                <img
                                    alt="Buscar"
                                    src={lupaNegra}
                                    style={{ height: '1.3rem', width: '1.3rem' }}
                                />
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className='col-3 justify-content-center d-flex'>
                        <button style={{ backgroundColor: '#D9D9D9', borderRadius: '5px', padding: '10px 20px', border: 'none', cursor: 'pointer', fontFamily: 'Roboto Slab, sans-serif' }} onClick={handleAñadirUsuario}>
                            Añadir Usuarios
                        </button>
                    </div>
                </div>
            </div>
            <div className="container-fluid p-0" style={{ height: 'calc(100vh - 14rem)', width:'95%', overflowY: 'auto',  opacity: hayVentanas ? 0.4 : 1 }}>
                {renderUsuarios(usuarios)}
            </div>
        </div>
        {/**PARA PANTALLAS PEQUEÑAS*/}
        <div className='d-block d-md-none '>
            {/**Usuarios*/}
            <div className='container-fluid d-flex pt-2 pr-2 pl-2'style={{opacity: hayVentanas ? 0.4 : 1}} >
                <div className='container-fluid p-0'>
                    <div className='row-fluid text-center mb-1'>
                        <span className='text-black customFontSizeTextoPequeño' > Estos son los usuarios que tienen acceso a la aplicación </span>
                    </div>
                    <div className='row-fluid justify-content-center d-flex mb-2'>
                        <form className="d-flex position-relative col-10 mt-1" role="search" >
                            <div className="input-group">
                            <input
                                aria-label="Search"
                                className="form-control me-2"
                                placeholder="Buscar"
                                style={{ borderRadius: '2rem', border: '1px solid black', height: '2rem' }}
                                type="search"
                                value={searchTerm} 
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                                <button className="btn btn-outline-success" style={{ backgroundColor: 'transparent', border: 'none', bottom: '0', marginTop: '-0.2rem',  position: 'absolute', right: '0', top: '0', zIndex: '3'}} 
                                onClick={(e) => e.preventDefault()} >
                                <img
                                    alt="Buscar"
                                    src={lupaNegra}
                                    style={{ height: '1.3rem', width: '1.3rem' }}
                                />
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="container-fluid p-0" style={{ height: 'calc(100vh - 20vh)', width:'95%', overflowY: 'auto',  opacity: hayVentanas ? 0.4 : 1 }}>
                {renderUsuarios(usuarios)}
            </div>
        </div>
        {/** Pantalla de overlay para que no se pueda seleccionar ningún objeto o interactuar si hay alguna ventana */}
        {hayVentanas && (
            <div className="overlay" style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 2
            }}></div>
        )}
    </div>
    </>
    );
};

export default UsuariosAdmin;